// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress{background:#f2f1f4;height:8px;border-radius:8px}.progress__scale{border-radius:inherit;height:100%;background-color:#fe3c72;max-width:100%}", ""]);
// Exports
module.exports = exports;
